// @flow

import { API_ENDPOINT } from 'shared/config';

export const companySegments = {
  NEW: 'new',
  EXISTING: 'existing',
  RETURNING: 'returning'
};
export const getCompanySegment = (companyCodasId: string): Promise<string> =>
  fetch(`${API_ENDPOINT}/companies/${companyCodasId}/company_segment`, {
    credentials: 'include'
  }).then((res) => {
    if (!res.ok) throw res;

    return res
      .json()
      .then(({ company_segment }) =>
        unObfuscateCompanySegment(company_segment)
      );
  });

//  This function un-hides values sent from the api. These values are obfuscated since it is possible for a user
//  to work out whether a company has used Funding Circle before; they could do this
//  by observing the segment name result queried while using the contact details entry screen
function unObfuscateCompanySegment(segment) {
  switch (segment) {
    case '0':
      return companySegments.NEW;
    case '1':
      return companySegments.RETURNING;
    case '2':
      return companySegments.EXISTING;
    default:
      return segment;
  }
}
